import {
  HighContrastSelector,
  IRawStyle,
  ITheme,
  memoizeFunction,
} from "@fluentui/react";

import {
  baseFabricFocusSelector,
  commonHighContrastFocusedDisabledStyles,
  commonHighContrastHoverFocusStyles,
  commonHighContrastOutlineFocusedDisabled,
  commonHighContrastOutlineHoverFocus,
  getInnerBorderStyles,
  getStandardControlSemanticColorsWithTheme,
  StandardControlSemanticColors,
} from "./";

export const getCommonIsFocusVisibleStyles = memoizeFunction(
  (theme: ITheme): IRawStyle[] => {
    const standardControlSemanticColors: StandardControlSemanticColors =
      getStandardControlSemanticColorsWithTheme(theme);
    const style = [
      {
        selectors: {
          ":after": [
            getInnerBorderStyles({
              width: 2,
              color: standardControlSemanticColors.focusedBorderColor,
              gap: -1,
            }),
            { [HighContrastSelector]: { border: "none" } },
          ],
        },
      },
      commonHighContrastOutlineHoverFocus,
      commonHighContrastHoverFocusStyles,
    ];
    return style;
  }
);

export const getCommonDisabledIsFocusVisibleStyles = memoizeFunction(
  (theme: ITheme): IRawStyle[] => {
    const standardControlSemanticColors: StandardControlSemanticColors =
      getStandardControlSemanticColorsWithTheme(theme);
    const style = [
      {
        backgroundColor: standardControlSemanticColors.disabledBackgroundColor,
        selectors: {
          ":after": [
            getInnerBorderStyles({
              width: 2,
              color: standardControlSemanticColors.focusedBorderColor,
              gap: -1,
            }),
            { [HighContrastSelector]: { border: "none" } },
          ],
        },
      },
      commonHighContrastOutlineFocusedDisabled,
      commonHighContrastFocusedDisabledStyles,
    ];
    return style;
  }
);

export const getCommonActiveStyles = memoizeFunction(
  (theme: ITheme): IRawStyle[] => {
    const standardControlSemanticColors: StandardControlSemanticColors =
      getStandardControlSemanticColorsWithTheme(theme);
    const style = [
      {
        backgroundColor: standardControlSemanticColors.pressedBackgroundColor,
        color: standardControlSemanticColors.textColor,
      },
      commonHighContrastOutlineHoverFocus,
      commonHighContrastHoverFocusStyles,
    ];
    return style;
  }
);

export const commonMozFocusInnerStyles = {
  border: "0",
};

export const getButtonStateStyles = memoizeFunction(
  (theme: ITheme, expanded?: boolean, disabled?: boolean): IRawStyle => {
    const standardControlSemanticColors: StandardControlSemanticColors =
      getStandardControlSemanticColorsWithTheme(theme);
    if (expanded) {
      return {
        backgroundColor: standardControlSemanticColors.expandedBackgroundColor,
        color: standardControlSemanticColors.textColor,
        selectors: {
          ":focus": {
            outline: "0",
          },
          ":hover": {
            backgroundColor:
              standardControlSemanticColors.expandedBackgroundColor,
            color: standardControlSemanticColors.textColor,
          },
          [`${baseFabricFocusSelector}, &:focus`]: disabled
            ? getCommonDisabledIsFocusVisibleStyles(theme)
            : getCommonIsFocusVisibleStyles(theme),
        },
      };
    }
    return {
      selectors: {
        ":hover": {
          backgroundColor: standardControlSemanticColors.hoverBackgroundColor,
          color: standardControlSemanticColors.textColor,
        },
        ":focus": {
          outline: "0",
        },
        [`${baseFabricFocusSelector}, &:focus`]: disabled
          ? getCommonDisabledIsFocusVisibleStyles(theme)
          : getCommonIsFocusVisibleStyles(theme),
        ":active": getCommonActiveStyles(theme),
        "::-moz-focus-inner": commonMozFocusInnerStyles,
      },
    };
  }
);
